module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "text-item clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.textReal))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6323651a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/text-printer/printer-item.vue
// module id = 239
// module chunks = 0